import React from 'react';

import { useTranslation } from 'react-i18next';
import { Alert } from '../../../../../components/Alert';
import { IconButton } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router';
import { ROUTES } from '../../../../../routes/Routes';
import { IOngoingActivityAlert } from './interfaces';

export const OngoingActivityAlert: React.FC<IOngoingActivityAlert> = ({
  ongoingActivity,
}): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Alert
      title={t('activities:alerts.ongoingActivity.title')}
      severity="info"
      action={
        <IconButton
          color="inherit"
          onClick={() =>
            navigate(ROUTES.activities.details(ongoingActivity.id))
          }
        >
          <ArrowForwardIcon color="inherit" />
        </IconButton>
      }
    >
      {t('activities:alerts.ongoingActivity.body', {
        title: ongoingActivity.title,
      })}
    </Alert>
  );
};
